import { useEffect, useState } from "react";
import {Link, useHistory, useLocation} from "react-router-dom";
import { GoogleLogout } from "react-google-login";
import { makeStyles } from "@material-ui/styles";

const account_data_api_url = "https://fcsn6t.deta.dev/account/db_data";
const personal_articles_api_url =
  "https://fcsn6t.deta.dev/article/query_user_articles";
const clientId =
    "926693198610-ebli6ii5b420hflubloorbvkf53lqc51.apps.googleusercontent.com";

const useStyles = makeStyles({
  title: {
    display: "inline",
    paddingRight: "2em"
  },
  article_container: {
    marginTop: "4em"
  },
  article: {
    marginTop: "2.3em",
    marginLeft: "4px",
    border: "3px solid black"
  }
})

const Useradmin = () => {
  const [authToken, setAuthtoken] = useState(null);
  const [userDataAdmin, setUserdataAdmin] = useState({
    user_data: null,
    user_articles: null,
  });
  const [apiError, setApierror] = useState("");
  const router_hystory = useHistory();
  const router_location = useLocation();
  const styles = useStyles()
  const fetchData = (auth_token) => {
    let user_data_apidata;
    let user_articles_apidata;
    fetch(account_data_api_url, {
      method: "GET",
      headers: {
        "X-Token": auth_token,
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (json.error) {
          if (json.error === "Token expire") {
            console.log(json.error);
            router_hystory.push("/login");
          } else {
            setApierror(json.error + " Reload page");
            window.location.pathname = router_location.pathname;
          }
        } else {
          user_data_apidata = json;
          fetch(personal_articles_api_url, {
            method: "GET",
            headers: {
              "X-Token": auth_token,
            },
          })
            .then((data) => data.json())
            .then((json) => {
              if (json.error) {
                if (json.error === "Token expire") {
                  console.log(json.error);
                  router_hystory.push("/login");
                } else {
                  setApierror(json.error + " Reload page");
                  window.location.pathname = router_location.pathname;
                }
              } else {
                user_articles_apidata = json;
                setAuthtoken(auth_token);
                setUserdataAdmin({
                  ...userDataAdmin,
                  user_data: user_data_apidata,
                  user_articles: user_articles_apidata,
                });
              }
            });
        }
      });
  };

  const logout = () => {
    setUserdataAdmin({
      user_data: null,
      user_articles: null,
    });
    sessionStorage.removeItem("xtoken");
    router_hystory.push("/login")
  }
  useEffect(() => {
    let stor_token = sessionStorage.getItem("xtoken");
    if (stor_token) {
      let authtoken = JSON.parse(stor_token).id_token;
      fetchData(authtoken);
    } else {
      router_hystory.push("/login");
    }
  }, []);
  const parse_user_personal_articles = () => {
    if (userDataAdmin.user_articles) {
      let articles = userDataAdmin.user_articles;
      return articles.map((article, index) => {
        return (
          <article key={index} className={styles.article}>
            <h4>{article.title}</h4>
            <p>{article.body}</p>
          </article>
        );
      });
    } else {
      return <span>Caricamento...</span>;
    }
  };
  let user_personal_articles_viewer = parse_user_personal_articles();

  const parse_user_data = () => {
    if (userDataAdmin.user_data) {
      let user_data = userDataAdmin.user_data;
      return (
        <span>
          <p>name: {user_data.name}</p>
          <p>email: {user_data.email}</p>
        </span>
      );
    } else {
      <span>Caricamento...</span>;
    }
  };

  let user_data_viewer = parse_user_data();

  return (
    <div>
      <h3>{apiError}</h3>
      <div>{user_data_viewer}
      <GoogleLogout
            clientId={clientId}
            buttonText="Logout"
            onLogoutSuccess={logout}
          ></GoogleLogout></div>
          <div className={styles.article_container}>
            {user_personal_articles_viewer}
          </div>
    </div>
  );
};

export default Useradmin;
